import type { IPublicClientApplication } from '@azure/msal-browser';
import { AppProvider } from '@app/provider';
import { AppRouter } from '@app/router';

interface AppProps {
  msalInstance: IPublicClientApplication;
}

export default function App({msalInstance}: AppProps) {
  return (
    <AppProvider msalInstance={msalInstance}>
      <AppRouter/>
    </AppProvider>
  );
}
